export const FooterNote = ({ note }: { note: string }) => {
    return (
        <div className="text-xs bg-brand-blueLight text-brand-blueDark w-full max-w-xs text-center p-1 mx-auto">
            <div className="border border-dashed border-white p-2 space-y-1">{note}</div>
        </div>
    );
};
